import {Divider} from "@mui/material";
import React from "react";

function ListDivider() {
	return <Divider component="li" sx={{my: 1}} />;
}

export default ListDivider;
